import { Card, CardContent, CardHeader, CardTitle } from "@shared/ui/card";
import { Activity, ArrowDownRight, ArrowUpRight, Database, Users, Zap } from "lucide-react";
import { useIntl } from "react-intl";

export function StatsCards() {
	const intl = useIntl();

	const stats = [
		{
			label: intl.formatMessage({
				id: "dashboard.stats.activeUsers.label",
				defaultMessage: "Active users",
			}),
			value: "12,438",
			delta: "+8.2%",
			trend: "up" as const,
			icon: Users,
			hint: intl.formatMessage({
				id: "dashboard.stats.activeUsers.hint",
				defaultMessage: "vs last 7 days",
			}),
		},
		{
			label: intl.formatMessage({
				id: "dashboard.stats.apiRequests.label",
				defaultMessage: "API requests",
			}),
			value: "1.84M",
			delta: "+12.4%",
			trend: "up" as const,
			icon: Zap,
			hint: intl.formatMessage({
				id: "dashboard.stats.apiRequests.hint",
				defaultMessage: "last 24 hours",
			}),
		},
		{
			label: intl.formatMessage({
				id: "dashboard.stats.databaseSize.label",
				defaultMessage: "Database size",
			}),
			value: "4.7 GB",
			delta: "+0.3 GB",
			trend: "up" as const,
			icon: Database,
			hint: intl.formatMessage({
				id: "dashboard.stats.databaseSize.hint",
				defaultMessage: "of 8 GB plan",
			}),
		},
		{
			label: intl.formatMessage({
				id: "dashboard.stats.errorRate.label",
				defaultMessage: "Error rate",
			}),
			value: "0.42%",
			delta: "-0.08%",
			trend: "down" as const,
			icon: Activity,
			hint: intl.formatMessage({
				id: "dashboard.stats.errorRate.hint",
				defaultMessage: "last 24 hours",
			}),
		},
	];

	return (
		<section className="grid gap-4 sm:grid-cols-2 lg:grid-cols-4">
			{stats.map((s) => {
				const Icon = s.icon;
				const TrendIcon = s.trend === "up" ? ArrowUpRight : ArrowDownRight;
				return (
					<Card key={s.label}>
						<CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
							<CardTitle className="text-sm font-medium text-muted-foreground">{s.label}</CardTitle>
							<Icon className="h-4 w-4 text-muted-foreground" />
						</CardHeader>
						<CardContent>
							<div className="text-2xl font-semibold">{s.value}</div>
							<div className="mt-1 flex items-center gap-1 text-xs">
								<span
									className={
										s.trend === "up"
											? "inline-flex items-center text-primary"
											: "inline-flex items-center text-destructive"
									}
								>
									<TrendIcon className="h-3 w-3" />
									{s.delta}
								</span>
								<span className="text-muted-foreground">{s.hint}</span>
							</div>
						</CardContent>
					</Card>
				);
			})}
		</section>
	);
}
